import React from "react";
import { compose } from "redux";
import classNames from "classnames";
import { connect } from "react-redux";
import { Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { WorkDayMapper } from "features/planner/planner.mappers";
import { WORK_SCHEDULE_STATUS } from "features/planner/planner.constants";
import { getWorkDaysFromState } from "features/planner/planner.selectors";
import WorkScheduleReportFlexDays from "features/planner/report/workSchedule/components/WorkScheduleReportFlexDays";

const CalendarWorkDay = ({ date, classes, workDay, children, isSelected }) => {
  const status = workDay.get("status");

  return (
    <Grid
      container
      className={classNames({
        [classes.isToday]: date.isSame(undefined, "day"),
        [classes.isSelected]: isSelected,
        [classes.workDayOff]: [
          WORK_SCHEDULE_STATUS.OFF,
          WORK_SCHEDULE_STATUS.OFF_FLEX,
        ].includes(status),
      })}
    >
      {status === WORK_SCHEDULE_STATUS.OFF_FLEX && (
        <WorkScheduleReportFlexDays count={1} />
      )}
      <Typography
        className={classNames(classes.dateDay, {
          [classes.dateDayOnOrOff]: !!status,
        })}
      >
        {date.date()}
      </Typography>
      {children}
    </Grid>
  );
};

CalendarWorkDay.defaultProps = {
  workDay: WorkDayMapper.initial(),
};

const styles = theme => ({
  isSelected: {
    "&$workDayOff": {
      background: "transparent",
    },
  },
  workDayOff: {
    background: theme.altus.calendar.workdayOffColor.main,
    "&:hover": {
      background: theme.altus.calendar.workdayOffColor.hover,
    },
  },
  dateDay: {
    fontSize: "0.6rem",
    lineHeight: "0.6rem",
    position: "absolute",
    right: theme.spacing(0.5),
    bottom: theme.spacing(0.5),
    zIndex: theme.zIndex.calendarDay,
    color: theme.palette.text.secondary,
  },
  dateDayOnOrOff: {
    "&$dateDay": {
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  isToday: {
    "& $dateDay": {
      right: 1,
      bottom: 1,
      display: "flex",
      borderRadius: "50%",
      alignItems: "center",
      justifyContent: "center",
      width: theme.spacing(2),
      height: theme.spacing(2),
      lineHeight: theme.spacing(2),
      color: theme.palette.primary.contrastText,
      background: theme.altus.calendar.contrastColor,
    },
  },
});

export default compose(
  connect((state, { date }) => ({
    workDay: getWorkDaysFromState(state, date.startOf("day").toISOString()),
  })),
  withStyles(styles),
  React.memo,
)(CalendarWorkDay);
